class DeployerCartAnnouncements {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.setupAnnouncements();
    });
  }

  setupAnnouncements() {
    const announcementBar = document.getElementById('deployer-announcements');
    if (!announcementBar) return;
    
    const slides = announcementBar.querySelectorAll('.deployer-announcement-slide');
    const dots = announcementBar.querySelectorAll('.deployer-announcement-dot');
    
    if (slides.length <= 1) return;
    
    this.announcementBar = announcementBar;
    this.slides = slides;
    this.dots = dots;
    this.currentSlide = 0;
    this.autoRotateInterval = null;
    
    this.bindEvents();
    this.adjustSliderHeight();
    this.startAutoRotate();
  }

  showSlide(index) {
    // Marquer l'ancien slide comme sortant
    this.slides.forEach((slide, i) => {
      slide.classList.remove('active', 'exit-left');
      if (i === this.currentSlide && i !== index) {
        slide.classList.add('exit-left');
      }
    });
    
    // Petit délai pour la transition
    setTimeout(() => {
      this.slides.forEach((slide, i) => {
        slide.classList.remove('active', 'exit-left');
        if (i === index) {
          slide.classList.add('active');
        }
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
      this.currentSlide = index;
      
      // Ajuster la hauteur du conteneur selon le contenu actif
      this.adjustSliderHeight();
    }, 100);
  }

  adjustSliderHeight() {
    const activeSlide = this.slides[this.currentSlide];
    if (activeSlide) {
      const slideHeight = activeSlide.scrollHeight;
      this.announcementBar.querySelector('.deployer-announcements-slider').style.height = slideHeight + 'px';
    }
  }

  nextSlide() {
    const nextIndex = (this.currentSlide + 1) % this.slides.length;
    this.showSlide(nextIndex);
  }

  startAutoRotate() {
    this.autoRotateInterval = setInterval(() => {
      this.nextSlide();
    }, 4000);
  }

  stopAutoRotate() {
    if (this.autoRotateInterval) {
      clearInterval(this.autoRotateInterval);
      this.autoRotateInterval = null;
    }
  }

  bindEvents() {
    // Navigation par points
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.showSlide(index);
        this.stopAutoRotate();
        // Redémarrer après 8 secondes
        setTimeout(() => {
          this.startAutoRotate();
        }, 8000);
      });
    });
    
    // Pause sur hover
    this.announcementBar.addEventListener('mouseenter', () => {
      this.stopAutoRotate();
    });
    
    this.announcementBar.addEventListener('mouseleave', () => {
      this.startAutoRotate();
    });
  }
}

// Initialiser la classe
new DeployerCartAnnouncements(); 